import React from 'react';
import LegendItem from '../legend-item';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

export default function LegendItems({ items }: Props) {
	return (
		<>
			{items.map((item, index) => (
				<LegendItem key={index}>
					{item.icon}
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.legendItemText}>{item.text}</div>
				</LegendItem>
			))}
		</>
	);
}
